module.exports = __webpack_public_path__ + "assets/media/morning.2e362a06.mp3";